import { shapes } from '@1x2network/particle_trail'
import type { ShapeType } from '../../types/ShapeOptions'
import { SwooshShape } from './SwooshShape'

export const allShapes = { ...shapes, Swoosh: SwooshShape }

export function makeShape<K extends keyof ShapeType>(
    kind: K,
    options: ConstructorParameters<ShapeType[K]>[0],
): InstanceType<ShapeType[K]> {
    const Shape = allShapes[kind]
    return new Shape(options) as InstanceType<ShapeType[K]>
}
